import axios, { AxiosRequestConfig } from 'axios';

const httpPut = async (url: string, data: any, config?: AxiosRequestConfig) => {
  const response = await axios.put(url, data, config);
  return response;
};

export default httpPut;
